import React from 'react';

const Unfurnished = props => (
  <svg
    width={54}
    height={54}
    viewBox="0 0 54 54"
    preserveAspectRatio="xMidYMid"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path fill={'#FFF'} opacity={0.01} d="M0 0h54v54H0z" />
      <g stroke={'#224251'} strokeLinecap="round" strokeLinejoin="round">
        <path d="M13.542 35.015v2.882m26.916-2.882v2.882m-29.75-11.529v5.764c0 1.591 1.267 2.883 2.834 2.883h26.916c1.564 0 2.834-1.292 2.834-2.883v-5.764" />
        <path d="M39.042 26.368v1.44c0 .795-.635 1.442-1.417 1.442h-21.25a1.43 1.43 0 0 1-1.417-1.441v-1.441m25.5-2.072v-.81c0-3.186-2.537-5.765-5.666-5.765H19.208c-3.13 0-5.666 2.579-5.666 5.765v.832" />
        <path d="M10.708 26.368c0-1.197.95-2.162 2.125-2.162 1.173 0 2.125.965 2.125 2.162m28.334 0c0-1.197-.952-2.162-2.125-2.162-1.175 0-2.125.965-2.125 2.162m-12.75-8.648v11.53" />
      </g>
      <g strokeLinecap="square">
        <path d="M8.455 46.545 47.556 7.444" stroke={'#FFF'} strokeWidth={7} />
        <path d="M8.455 46.545 47.556 7.444" stroke={'#224251'} />
      </g>
    </g>
  </svg>
);

export default Unfurnished;
